<template>

  <div class="hpanel contact-panel">
    <div class="panel-heading">
      <router-link :to="{name: 'ReceiveQuestion', params: {question_id: question.id}}" :title="question.title" >{{question.title|truncate(47)}}</router-link>

      <div class="panel-tools">
        <div class="btn-group">
          <router-link class="btn btn-xs btn-info" :to="{name: 'ReceiveQuestion', params: {question_id: question.id}}"><i class="fa fa-eye"></i> View</router-link>
          <button class="btn btn-xs btn-danger " data-toggle="modal" :data-target="'#deleteQuestion-' + question.id"><i class="fa fa-remove"></i></button>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="row">
        <div class="col-xs-8">

          <p v-if="question.short_description">
            {{question.short_description}}
          </p>
          <p v-else style="font-style: italic">
            Brief project description...
          </p>
        </div>
        <div class="col-sm-4 project-info">
          <div class="project-action ">
          </div>
        </div>

      </div>
    </div>
    <div class="panel-footer contact-footer">
      <div class="row">
        <div class="col-xs-4 border-right"> <div class="contact-stat"><span>Status: </span> <strong>{{question.status.name}}</strong></div> </div>
        <div class="col-xs-4 border-right"> <div class="contact-stat"><span>Broker: </span> <strong>{{question.consultant.email}}</strong></div> </div>
        <div class="col-xs-4"> <div class="contact-stat"><span>Start & End: </span> <strong>{{question.start_date | moment('LL')}} - {{question.end_date | moment('LL')}}</strong></div> </div>
      </div>
    </div>

    <div class="modal fade hmodal-danger" :id="'deleteQuestion-' + question.id" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete Question</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this question: {{question.title}}?</h3>
            <div>
              <span>Deleting a question is irreversible</span>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="deleteQuestion">Delete Question</vue-ladda>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
  .panel-tools a {
    color: white;
  }
</style>

<script>
import axios from 'axios'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['question'],
  name: 'QuestionListRow',
  watch: {
    refresh: function (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    deleteQuestion: function (e) {
      e.preventDefault()

      axios.delete('/question/receive/' + this.question.id)
        .then((response) => {
          this.submit.loading = false
          $('#' + 'deleteQuestion-' + this.question.id).modal('hide')
          this.$emit('input', true)
        })
        .catch((error) => {
          this.submitProject.loading = false
        })
    }
  },
  data () {
    return {
      refresh: false,
      submit: {
        loading: false,
        dataStyle: 'zoom-in'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receiveQuestion/QuestionListRow.vue